import { render, staticRenderFns } from "./MonitorList.vue?vue&type=template&id=53977c8f&scoped=true"
import script from "./MonitorList.vue?vue&type=script&lang=js"
export * from "./MonitorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53977c8f",
  null
  
)

export default component.exports